import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'isBase64',
    standalone: false
})
export class IsBase64Pipe implements PipeTransform {
  public transform(value?: string | null): boolean {
    if (!value) { return false }
    if (typeof value !== 'string') { return false }

    return value.includes('base64')
  }

  public isBase64(value?: string | null): boolean {
    return this.transform(value)
  }
}
